<template>
<div class="cont">
  <div class="toutu">
    <img src="../../assets/csrs_banner.png" /></div>  
	<img src="../../assets/csrs_yy.png">
  <div class="div_t" style="margin-top: 70px;">
	<div style="margin: auto;width: 100%;text-align: center;"><img src="../../assets/founder.png"></div>
<p style="font-size:42.23px;text-align: center;letter-spacing: 10px;margin-top: 30px;">创始人说</p>
<p class="jituo">当第一次得知生命在身上寄托</p>
<p class="tiaodong">当第一次感知TA的回应与跳动</p>
<div class="sanyuan">
	<img src="../../assets/sy.png">
</div>
<div class="wxzx">
<p class="wuxu">无需刻意学习什么就已理解“母亲”的含义 </p>
<p class="xiangjian">相见是一场漫长的等待</p>
<p class="dengdai">在等待里的每一天，小心翼翼的呵护</p>
<p class="xiwang">希望能传送给宝贝优质健康的营养</p>
<p class="newp">宝宝是孕妈的心头肉，我们了解。宝宝的健康是孕妈的心之所向，我们懂得。为了在复杂的市场中，寻得一片净土，无数孕妈汇聚到燕铺中来，她们相信燕铺，而燕铺也始终以高品质、更安全的燕窝回馈给她们。</p>
</div>
<div class="tf"><img src="../../assets/rongyi.png"></div>
<div class="ry_c">
在对燕窝的选择上，燕铺万里挑一。在适合金丝燕生存的栖息地——印尼，从燕盏的采集到最后的成品，燕铺跟踪到底。每一个环节燕铺都亲自见证。为孕妈和宝宝选择更好的燕窝，传递更佳的营养与品质，是燕铺理应做的，也是孕妈更该得到的。	
</div>
<div class="yw">
	<img src="../../assets/yongxin.png">
</div>
<div class="rensheng">
	一路走来，从孕妈到创业者，初心未变，始终自信着，坚持着。在寻找高品质燕窝的路上，燕铺作为孕妈的眼睛，从不敢有丝毫松懈。我们深知每一盏燕窝后面都代表着每一个家庭，每一盏燕窝都承载了燕铺对孕妈的祝福。
</div>
<div class="rw">
	<img src="../../assets/csrs_rw.png">
</div>
  </div>
</div>
</template>

<script>
	
export default {
  name: 'mystar',
  data () {
    return {
      
    }
  },
  methods:{
			
		}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cont {
    width: 1120px;
    margin: 0 auto;
    height: 100%;
}
.toutu {
    width: 1120px;
    margin: auto;
}

.toutu img {
    width: 100%;
}

	.jituo{
			margin-top: 50px;
			font-size: 23px;
			text-align:center;
			color: #4e4e4e;
		}
		.tiaodong{
			margin-top: 20px;
			font-size: 23px;
			text-align:center;
			color: #4e4e4e;
		}
		.sanyuan{
			margin: auto;
			text-align: center;
			margin-top: 50px;
		}
	.wxzx p{
		text-align: center;
		margin-top: 32px;
		font-size: 23px;
		color: #4e4e4e;
	}
	.wxzx .newp{text-indent: 48px; max-width: 950px; margin: 32px auto 0; font-size: 23px; line-height: 65px; text-align: left !important;}
	.wxzx{
		margin-top: 53px;
	}
	.tf{
		width: 452px;
		overflow: auto;
		margin: auto;
		margin-top: 66px;
	}
	.ry_c{
		width: 944px;
		height: 220px;
		margin: auto;
		margin-top: 74px;
		font-size: 23px;
		text-indent: 2em;
		color: #4e4e4e;
		line-height: 58px;
		letter-spacing: 1px;
		text-align: left;
	}
	.yw{
		width: 363px;
		overflow:auto;
		margin: auto;
		margin-top: 90px;
	}
	.yw img{
		width: 100%;
	}
	.rensheng{
		width: 950px;
		height: 85px;
		margin: auto;
		margin-top: 64px;
		text-indent: 2em;
		color: #4e4e4e;
		font-size: 23px;
		line-height: 48px;
		letter-spacing: 1px;
		text-align: left;
	}
	.rw{
		margin: auto;
		margin-top: 130px;
		overflow: auto;
		
	}
@media(max-width: 750px) {
   .cont{width:100%; margin: 0 auto;}
   .toutu{ width: 100%; overflow: hidden}
   .toutu img{ width: 160%; margin-left: -30%;}
   .cont>img{ width: 100%}
   .div_t{ width:690px; margin: 0 auto;}
   .ry_c,.rensheng,.rw img{ width: 690px;}
   .wxzx p{ font-size: 24px}
}     

</style>



// WEBPACK FOOTER //
// src/components/story/csrs.vue